import { render, staticRenderFns } from "./videoDrr.vue?vue&type=template&id=a20748cc&scoped=true&"
import script from "./videoDrr.vue?vue&type=script&lang=js&"
export * from "./videoDrr.vue?vue&type=script&lang=js&"
import style0 from "./videoDrr.vue?vue&type=style&index=0&id=a20748cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20748cc",
  null
  
)

export default component.exports